import { jsx as _jsx } from "react/jsx-runtime";
import { formatInternational } from 'lib-shared-phone-numbers';
const PrettyNumber = ({ number }) => {
    const { e164_format = '' } = number || {};
    const prettyNumber = formatInternational(e164_format) || e164_format;
    return _jsx("span", { children: prettyNumber });
};
export default PrettyNumber;
